var ISN = {

    settings: {
        verbose:            false,
        companykey:         "",
        ams:				false,
        advanced_editor:    false,
        office:             { id: '', name: '', manager: '', manager_email: '', phone: '', address1: '', address2: '', city: '', state: '', state_abbreviation: '', zip: '', latitude: 0, longitude: 0 },
        user:               { id: "", username: "", first: "", last: "", email: "", mobile: "", fee_visibility: true, grants: [] },
        fontsize:           null,
        system_message:     "",
        system_message_id:  "",
        gapi_v3_key:        "",
        visualization_callbacks: [],
        visualization_loaded: false,
        logentries_api_key: "2a0660e7-1ab9-4045-9b68-589240177b22",
        redactor: ['format', 'bold', 'italic', 'deleted', 'lists', 'image', 'file', 'link', 'horizontalrule'],
        redactor_allowed_tags: ["code", "span", "div", "label", "a", "br", "p", "b", "i", "del", "strike", "u",
            "img", "video", "audio", "iframe", "object", "embed", "param", "blockquote",
            "mark", "cite", "small", "ul", "ol", "li", "hr", "dl", "dt", "dd", "sup", "sub",
            "big", "pre", "code", "figure", "figcaption", "strong", "em", "table", "tr", "td",
            "th", "tbody", "thead", "tfoot", "h1", "h2", "h3", "h4", "h5", "h6", "font"],
        redactor_denied_tags: ['meta', 'script', 'applet'],
        redactor_btns: {
            fontsize: {
                title: 'Font Size',
                'class': 'redactor_btn_fontsize',
                dropdown: {
                    nofontsize: {
                        title: 'none',
                        callback: function(obj, event, key) { ISN.redactor_modify_font_size(obj, event, key); }
                    },
                    fontsize2: {
                        title: '<span style="font-size:10pt">10</span>',
                        callback: function(obj, event, key) { ISN.redactor_modify_font_size(obj, event, key); }
                    },
                    fontsize3: {
                        title: '<span style="font-size:11pt">11 (Normal)</span>',
                        callback: function(obj, event, key) { ISN.redactor_modify_font_size(obj, event, key); }
                    },
                    fontsize4: {
                        title: '<span style="font-size:12pt">12</span>',
                        callback: function(obj, event, key) { ISN.redactor_modify_font_size(obj, event, key); }
                    },
                    fontsize5: {
                        title: '<span style="font-size:13pt">13</span>',
                        callback: function(obj, event, key) { ISN.redactor_modify_font_size(obj, event, key); }
                    },
                    fontsize6: {
                        title: '<span style="font-size:14pt">14</span>',
                        callback: function(obj, event, key) { ISN.redactor_modify_font_size(obj, event, key); }
                    },
                    fontsize7: {
                        title: '<span style="font-size:18pt">18</span>',
                        callback: function(obj, event, key) { ISN.redactor_modify_font_size(obj, event, key); }
                    }
                }
            }
        },
        bs_datepicker_settings: {
            autoclose: true,
            todayBtn: 'linked',
            todayHighlight: true
        },
        tinymce: {
            init: function() {
                var settings = {};
                if (ISN.settings.advanced_editor) {
                    settings = {
                        plugins: [
                            "advlist autolink autosave link image lists charmap print preview hr anchor pagebreak spellchecker",
                            "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
                            "table directionality emoticons template textcolor paste"
                        ],

                        toolbar1: "code | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | styleselect formatselect fontselect fontsizeselect",
                        toolbar2: "cut copy paste | searchreplace | bullist numlist | outdent indent blockquote | undo redo | link unlink anchor image media | inserttime preview | forecolor backcolor",
                        toolbar3: "table | hr removeformat | subscript superscript | charmap emoticons | print fullscreen | ltr rtl | visualchars visualblocks nonbreaking template pagebreak restoredraft",
                        font_formats: "Arial=arial;Arial Black=Arial Black;Book Antiqua=Book Antiqua;Century Gothic=Century Gothic;Comic Sans MS=Comic Sans MS;Courier New=Courier New;Fixedsys=Fixedsys;Franklin Gothic Medium=Franklin Gothic Medium;Garamond=Garamond;Georgia=Georgia;Impact=Impact;Lucida Console=Lucida Console;Lucida Sans Unicode=Lucida Sans Unicode;Microsoft Sans Serif=Microsoft Sans Serif;Palatino Linotype=Palatino Linotype;System=System;Tahoma=Tahoma;Times New Roman=Times New Roman;Trebuchet MS=Trebuchet MS;Verdana=Verdana",

                        menubar: false,
                        toolbar_items_size: 'small',
                        image_advtab: true,
                        browser_spellcheck : true,
                        contextmenu: false,

                        paste_auto_cleanup_on_paste: true,
                        paste_remove_styles: true,
                        paste_remove_styles_if_webkit: true,
                        paste_strip_class_attributes: true,
                        remove_linebreaks: false,
                        fontsize_formats: "8pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt",
                        paste_word_valid_elements: "@[class],p,h3,h4,h5,h6,a[href|target],strong/b,div[align],br,table,tbody,thead,tr,td,ul,ol,li,img[src]",

                        style_formats: [
                            {title: 'Bold text', inline: 'b'},
                            {title: 'Red text', inline: 'span', styles: {color: '#ff0000'}},
                            {title: 'Red header', block: 'h1', styles: {color: '#ff0000'}},
                            {title: 'Example 1', inline: 'span', classes: 'example1'},
                            {title: 'Example 2', inline: 'span', classes: 'example2'},
                            {title: 'Table styles'},
                            {title: 'Table row 1', selector: 'tr', classes: 'tablerow1'}
                        ],
                        valid_children: '+body[style]'
                    };
                } else {
                    settings = {
                        menubar: false,
                        browser_spellcheck : true,
                        contextmenu: false,
                        plugins: [
                            "advlist autolink lists link image charmap print preview anchor",
                            "searchreplace visualblocks code fullscreen",
                            "insertdatetime media table paste textcolor"
                        ],
                        image_advtab: true,
                        fontsize_formats: "8pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt",
                        font_formats: "Arial=arial;Arial Black=Arial Black;Book Antiqua=Book Antiqua;Century Gothic=Century Gothic;Comic Sans MS=Comic Sans MS;Courier New=Courier New;Fixedsys=Fixedsys;Franklin Gothic Medium=Franklin Gothic Medium;Garamond=Garamond;Georgia=Georgia;Impact=Impact;Lucida Console=Lucida Console;Lucida Sans Unicode=Lucida Sans Unicode;Microsoft Sans Serif=Microsoft Sans Serif;Palatino Linotype=Palatino Linotype;System=System;Tahoma=Tahoma;Times New Roman=Times New Roman;Trebuchet MS=Trebuchet MS;Verdana=Verdana",
                        toolbar1: "code | undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist table outdent indent | link image",
                        toolbar2: "styleselect formatselect fontselect fontsizeselect forecolor backcolor",
                        valid_children: '+body[style]'
                    };
                }

                return settings;
            },
            init_lightweight: function() {
                settings = {
                    plugins: [
                        "link image lists hr anchor pagebreak spellchecker",
                        "visualblocks visualchars code nonbreaking",
                        "table directionality textcolor paste"
                    ],

                    toolbar1: "code | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | fontselect fontsizeselect | forecolor backcolor",
                    toolbar2: "cut copy paste | bullist numlist | outdent indent blockquote | undo redo",
                    toolbar3: "link unlink anchor image hr removeformat | subscript superscript | ltr rtl | visualchars visualblocks",

                    menubar: false,
                    toolbar_items_size: 'small',
                    image_advtab: true,

                    paste_auto_cleanup_on_paste: true,
                    paste_remove_styles: true,
                    paste_remove_styles_if_webkit: true,
                    paste_strip_class_attributes: true,
                    remove_linebreaks: false,
                    paste_word_valid_elements: "@[class],p,h3,h4,h5,h6,a[href|target],strong/b,div[align],br,table,tbody,thead,tr,td,ul,ol,li,img[src]",

                    style_formats: [
                        {title: 'Bold text', inline: 'b'},
                        {title: 'Red text', inline: 'span', styles: {color: '#ff0000'}},
                        {title: 'Red header', block: 'h1', styles: {color: '#ff0000'}},
                        {title: 'Example 1', inline: 'span', classes: 'example1'},
                        {title: 'Example 2', inline: 'span', classes: 'example2'},
                        {title: 'Table styles'},
                        {title: 'Table row 1', selector: 'tr', classes: 'tablerow1'}
                    ],
                    valid_children: '+body[style]'
                };
                return settings;
            }
        },
        send_agreement_dialog: null,
        porch: {
            order_modal: {
                data: null,
                template: null,
                change_callback: null,
                compile_template: function () {
                    var template = ISN.settings.porch.order_modal.template;
                    if (!template) {
                        template = $('#porch-order-status-modal-template').html();
                    }

                    return window.Handlebars.compile(template);
                },
                open: function (data, change_callback) {
                    if (typeof data === 'number') {
                        $.getJSON('/'+ISN.settings.companykey+'/orders/order-info-array?oid='+data)
                            .then(function(response) {
                                ISN.settings.porch.order_modal.open(response, change_callback);
                            });
                    } else {
                        ISN.settings.porch.order_modal.prep_data(data);
                        ISN.settings.porch.order_modal.change_callback = typeof change_callback === 'function' ? change_callback : null;

                        var template = ISN.settings.porch.order_modal.compile_template();
                        var dialog = bootbox.dialog(
                            {
                                size: 'large',
                                message: template({data: ISN.settings.porch.order_modal.data}),
                                title: 'Porch Status for OID ' + ISN.settings.porch.order_modal.data.oid,
                                buttons: {
                                    cancel: {
                                        label: 'Close',
                                        className: 'btn-default'
                                    }
                                }
                            }
                        );
                        dialog.on('shown.bs.modal', function () {
                            dialog.attr('id', 'porch-order-status-modal');
                        });
                    }
                },
                prep_data: function (data) {
                    var porch_data = data.porch;
                    var new_data = JSON.parse(JSON.stringify(porch_data));
                    new_data.oid = data.id;
                    new_data.agent_id = data.buyers_agent_id;
                    new_data.client_id = data.client_id;

                    var background_color = '';
                    if (porch_data.sent) {
                        background_color = ISN.settings.porch.success_reason_code_colors[0];
                    } else if (porch_data.status_code === ISN.settings.porch.get_status_code('STATUS_API_SUBMITTED')) {
                        background_color = ISN.settings.porch.success_reason_code_colors[3];
                    } else if (porch_data.status_code === ISN.settings.porch.get_status_code('STATUS_API_VALIDATION_ACCEPTED')) {
                        background_color = ISN.settings.porch.success_reason_code_colors[4];
                    } else if (porch_data.status_code !== false && porch_data.status_code >= 0) {
                        background_color = ISN.settings.porch.error_reason_code_color;
                    } else {
                        background_color = ISN.settings.porch.success_reason_code_colors[data.ready ? 1 : 2];
                    }

                    new_data.status_submitted = data.sent || (porch_data.status_code === ISN.settings.porch.get_status_code('STATUS_API_SUBMITTED'));
                    new_data.status_validation_accepted = data.sent || porch_data.status_code === ISN.settings.porch.get_status_code('STATUS_API_VALIDATION_ACCEPTED');
                    new_data.status_error = !data.sent && porch_data.status_code !== false && porch_data.status_code >= 0 && ['STATUS_API_SUBMITTED','STATUS_API_VALIDATION_ACCEPTED'].indexOf(ISN.settings.porch.get_status_key(porch_data.status_code)) === -1;
                    new_data.human_readable_status_index = ISN.settings.porch.get_status_index_human_readable_index(porch_data.status_code);
                    new_data.background_color = background_color;
                    new_data.resubmittable = !data.sent && porch_data.status_code < 100;

                    ISN.settings.porch.order_modal.data = new_data;
                },
                render: function () {
                    var template = ISN.settings.porch.order_modal.compile_template();
                    $('#porch-order-status-modal .modal-body > .bootbox-body').empty().append(template({data:ISN.settings.porch.order_modal.data}));
                },
                reload: function () {
                    $.getJSON('/'+ISN.settings.companykey+'/orders/order-info-array?oid='+ISN.settings.porch.order_modal.data.oid)
                        .then(function(response) {
                            ISN.settings.porch.order_modal.prep_data(response);
                            ISN.settings.porch.order_modal.render();
                            if (typeof ISN.settings.porch.order_modal.change_callback === 'function') {
                                ISN.settings.porch.order_modal.change_callback.call();
                            }
                        });
                },
                toggle_agent_opt_status: function () {
                    $.post('/'+ISN.settings.companykey+'/agent/porch-toggle', {aid:ISN.settings.porch.order_modal.data.agent_id})
                        .then(ISN.settings.porch.order_modal.reload);
                },
                toggle_client_opt_status: function () {
                    $.post('/'+ISN.settings.companykey+'/client/porch-toggle', {cid:ISN.settings.porch.order_modal.data.client_id})
                        .then(ISN.settings.porch.order_modal.reload);
                },
                submit_order_now: function () {
                    $('#porch-submit-response').hide();
                    $('#porch-submit-response-error').hide();
                    $('#porch-submit-error-details').hide()
                    $('#submit-porch-now-btn').hide();
                    $('#submitting-porch-now-btn').show();
                    $.post('/' + ISN.settings.companykey + '/order/send-porch-now', {oid: ISN.settings.porch.order_modal.data.oid})
                        .then(function (response) {
                            $('#submit-porch-now-btn').show();
                            $('#submitting-porch-now-btn').hide();
                            if (response.status === 'ok') {
                                $('#porch-submit-response').show();
                                ISN.settings.porch.order_modal.reload();
                            } else {
                                $('#porch-submit-response-error').show();
                                $('#porch-submit-error-message').text(response.message);
                                if (response.hasOwnProperty('details') && response.details && response.details !== '') {
                                    $('#porch-submit-error-details').show()
                                        .find('span:first')
                                        .text(response.details);
                                }
                            }
                        })
                }
            },
            order_details_modal: {
                template: null,
                compile_template: function () {
                    var template = ISN.settings.porch.order_details_modal.template;
                    if (!template) {
                        template = $('#porch-order-details-modal-template').html();
                    }

                    return window.Handlebars.compile(template);
                },
                open: function (oid) {
                    $.getJSON('/'+ISN.settings.companykey+'/order/porch-details?oid='+oid)
                        .then(function(response) {
                            var template = ISN.settings.porch.order_details_modal.compile_template();
                            var dialog = bootbox.dialog(
                                {
                                    size: 'large',
                                    message: template({data: response.data}),
                                    title: 'Porch Details for OID ' + oid,
                                    buttons: {
                                        cancel: {
                                            label: 'Close',
                                            className: 'btn-default'
                                        }
                                    }
                                }
                            );
                        });
                }
            },
            evergreen_modal: {
                data: null,
                template: null,
                change_callback: null,
                compile_template: function () {
                    // var template = ISN.settings.porch.evergreen_modal.template;
                    var template = null;
                    if (!template) {
                        template = $('#evergreen-modal-template').html();
                    }

                    return window.Handlebars.compile(template);
                },
                open: function (data, change_callback) {
                    if (typeof data === 'number') {
                        $.getJSON('/'+ISN.settings.companykey+'/orders/order-info-array?oid='+data)
                          .then(function(response) {
                              ISN.settings.porch.evergreen_modal.open(response, change_callback);
                          });
                    } else {
                        ISN.settings.porch.evergreen_modal.prep_data(data);
                        ISN.settings.porch.evergreen_modal.change_callback = typeof change_callback === 'function' ? change_callback : null;

                        var template = ISN.settings.porch.evergreen_modal.compile_template();
                        var dialog = bootbox.dialog(
                          {
                              size: 'large',
                              message: template({data: ISN.settings.porch.evergreen_modal.data}),
                              title: 'Evergreen Status for OID ' + ISN.settings.porch.evergreen_modal.data.oid,
                              buttons: {
                                  cancel: {
                                      label: 'Close',
                                      className: 'btn-default'
                                  }
                              }
                          }
                        );
                        dialog.on('shown.bs.modal', function () {
                            dialog.attr('id', 'evergreen-status-modal');
                        });
                    }
                },
                prep_data: function (data) {
                    var porch_data = data.porch;
                    var new_data = JSON.parse(JSON.stringify(porch_data));
                    new_data.oid = data.id;
                    new_data.agent_id = data.buyers_agent_id;
                    new_data.client_id = data.client_id;

                    var background_color = '';
                    if (porch_data.sent) {
                        background_color = ISN.settings.porch.success_reason_code_colors[0];
                    } else if (porch_data.status_code === ISN.settings.porch.get_status_code('STATUS_API_SUBMITTED')) {
                        background_color = ISN.settings.porch.success_reason_code_colors[3];
                    } else if (porch_data.status_code === ISN.settings.porch.get_status_code('STATUS_API_VALIDATION_ACCEPTED')) {
                        background_color = ISN.settings.porch.success_reason_code_colors[4];
                    } else if (porch_data.status_code !== false && porch_data.status_code >= 0) {
                        background_color = ISN.settings.porch.error_reason_code_color;
                    } else {
                        background_color = ISN.settings.porch.success_reason_code_colors[data.ready ? 1 : 2];
                    }

                    new_data.status_submitted = data.sent || (porch_data.status_code === ISN.settings.porch.get_status_code('STATUS_API_SUBMITTED'));
                    new_data.status_validation_accepted = data.sent || porch_data.status_code === ISN.settings.porch.get_status_code('STATUS_API_VALIDATION_ACCEPTED');
                    new_data.status_error = !data.sent && porch_data.status_code !== false && porch_data.status_code >= 0 && ['STATUS_API_SUBMITTED','STATUS_API_VALIDATION_ACCEPTED'].indexOf(ISN.settings.porch.get_status_key(porch_data.status_code)) === -1;
                    new_data.human_readable_status_index = ISN.settings.porch.get_status_index_human_readable_index(porch_data.status_code);
                    new_data.background_color = background_color;
                    new_data.resubmittable = !data.sent && porch_data.status_code < 100;

                    ISN.settings.porch.evergreen_modal.data = new_data;
                },
                render: function () {
                    var template = ISN.settings.porch.evergreen_modal.compile_template();
                    $('#evergreen-status-modal .modal-body > .bootbox-body').empty().append(template({data:ISN.settings.porch.evergreen_modal.data}));
                },
                reload: function () {
                    $.getJSON('/'+ISN.settings.companykey+'/orders/order-info-array?oid='+ISN.settings.porch.evergreen_modal.data.oid)
                      .then(function(response) {
                          ISN.settings.porch.evergreen_modal.prep_data(response);
                          ISN.settings.porch.evergreen_modal.render();
                          if (typeof ISN.settings.porch.evergreen_modal.change_callback === 'function') {
                              ISN.settings.porch.evergreen_modal.change_callback.call();
                          }
                      });
                },
                toggle_agent_opt_status: function () {
                    $.post('/'+ISN.settings.companykey+'/agent/evergreen-toggle', {aid:ISN.settings.porch.evergreen_modal.data.agent_id})
                      .then(ISN.settings.porch.evergreen_modal.reload);
                },
                toggle_client_opt_status: function () {
                    $.post('/'+ISN.settings.companykey+'/client/evergreen-toggle', {cid:ISN.settings.porch.evergreen_modal.data.client_id})
                      .then(ISN.settings.porch.evergreen_modal.reload);
                },
            },
            evergreen_details_modal: {
                template: null,
                compile_template: function () {
                    // var template = ISN.settings.porch.order_details_modal.template;
                    var template = null;
                    if (!template) {
                        template = $('#evergreen-details-modal-template').html();
                    }

                    return window.Handlebars.compile(template);
                },
                open: function (oid) {
                    $.getJSON('/'+ISN.settings.companykey+'/order/porch-details?oid='+oid)
                      .then(function(response) {
                          var template = ISN.settings.porch.evergreen_details_modal.compile_template();
                          var dialog = bootbox.dialog(
                            {
                                size: 'large',
                                message: template({data: response.data}),
                                title: 'Evergreen Details for OID ' + oid,
                                buttons: {
                                    cancel: {
                                        label: 'Close',
                                        className: 'btn-default'
                                    }
                                }
                            }
                          );
                      });
                }
            },
            get_status_key: function (code) {
                code = parseInt(code);
                for (var p in ISN.settings.porch.statuses) {
                    if (ISN.settings.porch.statuses.hasOwnProperty(p) && parseInt(ISN.settings.porch.statuses[p]) === code) {
                        return p;
                    }
                }
                return '';
            },
            get_status_code: function (slug) {
                for (var p in ISN.settings.porch.statuses) {
                    if (ISN.settings.porch.statuses.hasOwnProperty(p) && p === slug) {
                        return ISN.settings.porch.statuses[p];
                    }
                }
                return -1;
            },
            get_status_index_human_readable_index: function (code) {
                var index = 0;
                // statuses we don't index:
                var excluded = [
                    'STATUS_OTHER',
                    'STATUS_OUTSIDE_WINDOWS',
                    'STATUS_PORCH_DISABLED_GLOBAL',
                    'STATUS_PORCH_DISABLED_OFFICE',
                    'STATUS_COUNTRY_INVALID',
                    'STATUS_API_SUBMITTED',
                    'STATUS_API_VALIDATION_ACCEPTED',
                    'STATUS_API_ROUTING_COMPLETE'
                ];
                code = parseInt(code);
                for (var p in ISN.settings.porch.statuses) {
                    if (ISN.settings.porch.statuses.hasOwnProperty(p) && excluded.indexOf(p) === -1) {
                        index++;
                        if (parseInt(ISN.settings.porch.statuses[p]) === code) {
                            return index;
                        }
                    }
                }
                return -1;
            },
            get_status_description: function (code) {
                code = parseInt(code);
                for (var p in ISN.settings.porch.status_descriptions) {
                    if (ISN.settings.porch.status_descriptions.hasOwnProperty(p) && parseInt(p) === code) {
                        return ISN.settings.porch.status_descriptions[p];
                    }
                }
                return '';
            },
            statuses: [],
            status_descriptions: [],
            success_reason_code_colors: [
                // sent
                '#1cb244',
                // will send
                '#89CFF0',
                // waiting
                '#B0DFE5',
                // submitted, waiting for validation
                '#588BAE',
                // validated, waiting for processing
                '#9bd85b'
            ],
            error_reason_code_color: '#d6350c'
        },
        repair_pricer: {// MM: rer removal
            price: 0
        },
        flags: [],
        get_flag_by_uuid: function(uuid) {
            for (var i = 0, l = ISN.settings.flags.length; i < l; i++) {
                if (ISN.settings.flags[i].uuid === uuid) {
                    return ISN.settings.flags[i];
                }
            }
            return null;
        },
        get_flag_state: function(flagUuid, stateUuid) {
            var flag = ISN.settings.get_flag_by_uuid(flagUuid);
            if (flag) {
                return flag.states.find(function(s) {
                    return s.uuid === stateUuid;
                });
            }
            return null;
        },
        get_next_flag_state: function(flagUuid, currentStateUuid) {
            var flag = ISN.settings.get_flag_by_uuid(flagUuid);
            if (flag) {
                var states = flag.states;
                states.sort(function(a, b) {
                    return a.sequence - b.sequence;
                });
                var currentIndex = states.findIndex(function(s) {
                    return s.uuid === currentStateUuid;
                });
                if (currentIndex === -1 || currentIndex+1 === states.length) {
                    return states[0];
                } else {
                    return states[currentIndex+1];
                }
            }
        }
    },

    rer: null,// MM: rer removal

    LE: null,

    dom: {
        global:          null,
        headermenu:      null,
        logo:            null,
        system_message:  null
    },

    replacement_values:
    "Inspection Date (long)=inspectiondate-long;" +
    "Inspection Date (long no day name)=inspectiondate-long-no-dayname;" +
    "Inspection Date Created=datecreated;" +
    "Inspection Date Scheduled=datescheduled;" +
    "Inspection Duration=inspectionduration;" +
    "Inspection Time=inspectiontime;Inspection Day=inspectionday;" +
    "Previously Scheduled Inspection Time=previousinspectiontime;" +

    "Map to Inspection (100px)=map100;" +
    "Map to Inspection (250px)=map250;" +
    "Map to Inspection (512px)=map512;" +

    "Clickable Map to Inspection (100px)=googlemap100link;" +
    "Clickable Map to Inspection (250px)=googlemap250link;" +
    "Clickable Map to Inspection (512px)=googlemap512link;" +

    "Table of Fees=inspectionfeetable;" +
    "Table of Fees With Total=inspectionfeetabletotal;" +
    "HTML Div of Fees=inspectionfeediv;" +
    "HTML Div of Fees with Total=inspectionfeedivtotal;" +
    "Inspection's Total Fee=totalinspectionfee;" +
    "Inspection Fee=inspectionfee;" +
    "Inspection Total Tax=inspectiontotaltax;" +
    "Inspector's Id=inspectorid;" +
    "Inspector's Slug=inspectorslug;" +
    "Inspector's Username=inspectorusername;" +
    "Inspector's Display Name=inspectordisplayname;" +
    "Inspector's First Name=inspectorfirstname;" +
    "Inspector's Last Name=inspectorlastname;" +
    "Inspector's Initials=inspectorinitial;" +
    "Inspector's First Name Initial=inspectorfirstnameinitial;" +
    "Inspector's Last Name Initial=inspectorlastnameinitial;" +
    "Inspector's Email Address=inspectoremail;" +
    "Inspector's Website=inspectorurl;" +
    "Inspector's Phone Number=inspectorphone;" +
    "Inspector's Mobile=inspectormobile;" +
    "Inspector's Fax Number=inspectorfax;" +
    "Inspector's Bio=inspectorbio;" +
    "Inspector's License Type=inspectorlicensetype;" +
    "Inspector's License Number=inspectorlicensenumber;" +
    "Inspector's User Number=inspectorusernumber;" +
    "Inspector's Photo URL=inspectorphotourl;" +
    "Inspector's Photo 50px=inspectorphoto50;" +
    "Inspector's Photo 75px=inspectorphoto75;" +
    "Inspector's Photo 100px=inspectorphoto100;" +
    "Inspector's Photo 125px=inspectorphoto125;" +
    "Inspector's Photo 150px=inspectorphoto150;" +
    "Inspector's Photo 175px=inspectorphoto175;" +
    "Inspector's Photo 200px=inspectorphoto200;" +
    "Inspector's Photo 225px=inspectorphoto225;" +
    "Previously Selected Inspector1 Display Name=previous-inspector1-displayname;" +
    "Previously Selected Inspector2 Display Name=previous-inspector2-displayname;" +
    "Previously Selected Inspector3 Display Name=previous-inspector3-displayname;" +
    "Previously Selected Inspector4 Display Name=previous-inspector4-displayname;" +
    "Previously Selected Inspector5 Display Name=previous-inspector5-displayname;" +
    "Previously Selected Inspector6 Display Name=previous-inspector6-displayname;" +
    "Previously Selected Inspector7 Display Name=previous-inspector7-displayname;" +
    "Previously Selected Inspector8 Display Name=previous-inspector8-displayname;" +
    "Previously Selected Inspector9 Display Name=previous-inspector9-displayname;" +
    "Previously Selected Inspector10 Display Name=previous-inspector10-displayname;" +
    "Inspection Address 1=inspectionaddress1;" +
    "Inspection Address 2=inspectionaddress2;" +
    "Inspection City=inspectioncity;" +
    "Inspection State=inspectionstate;Inspection Zip=inspectionzip;" +
    "Year Built=yearbuilt;Square Feet=squarefeet;" +
    "Insurance Agent Display Name=insuranceagentsdisplayname;"+
    "Insurance Agent First Name=insuranceagentsfirstname;"+
    "Insurance Agent Last Name=insuranceagentslastname;" +
    "Insurance Agent Email=insuranceagentsemail;" +
    "Insurance Agent Work Phone=insuranceagentsworkphone;" +
    "Insurance Agent Mobile Phone=insuranceagentsmobilephone;" +
    "Insurance Agent Company=insuranceagentscompanyname;" +
    "Inspection Address=inspectionaddress;" +
    "Inspection Date=inspectiondate;" +
    "Previously Scheduled Inspection Date=previousinspectiondate;" +
    "Previously Scheduled Inspection Date and Time=previousinspectiondatetime;" +
    "Client Reference Number=crn;" +
    "Client's Display Name=clientsdisplayname;" +
    "Client's First Name=clientsfirstname;" +
    "Client's Last Name=clientslastname;" +
    "Client's Email=clientsemail;" +
    "Client's Website=clientsurl;" +
    "Client's Work Phone=clientsworkphone;" +
    "Client's Home Phone=clientshomephone;" +
    "Client's Mobile=clientsmobile;" +
    "Client's Address=clientsaddress;" +
    "Client's Address (line 1)=clientsaddress1;" +
    "Client's Address (line 2)=clientsaddress2;" +
    "Client's City=clientscity;" +
    "Client's State=clientsstate;" +
    "Client's Zip Code=clientszip;" +
    "Buyer's Agent Dashboard URL=buyersagentdashboardurl;" +
    "Buyer's Agent Dashboard Link=buyersagentdashboardlink;" +
    "Buyer's Agent Agency Name=buyersagentagencyname;" +
    "Buyer's Agent Agency Phone=buyersagentagencyphone;" +
    "Buyer's Agent Agency Logo URL=buyersagentagencylogourl;" +
    "Buyer's Agent Agency Logo=buyersagentagencylogo;" +
    "Buyer's Agent Agency Address=buyersagentagencyaddress;" +
    "Buyer's Agent Display Name=buyersagentdisplayname;" +
    "Buyer's Agent First Name=buyersagentfirstname;" +
    "Buyer's Agent Last Name=buyersagentlastname;" +
    "Buyer's Agent Email=buyersagentemail;" +
    "Buyer's Agent Web Site (URL)=buyersagenturl;" +
    "Buyer's Agent Web Site Link (clickable link)=buyersagenturllink;" +
    "Buyer's Agent Work Phone=buyersagentworkphone;" +
    "Buyer's Agent Mobile=buyersagentmobile;" +

    "Buyer's Agent Photo (75px)=buyersagentimage75;" +
    "Buyer's Agent Photo (100px)=buyersagentimage100;" +
    "Buyer's Agent Photo (150px)=buyersagentimage150;" +
    "Buyer's Agent Photo (250px)=buyersagentimage250;" +

    "Seller's Agent Display Name=sellersagentdisplayname;" +
    "Seller's Agent First Name=sellersagentfirstname;" +
    "Seller's Agent Agency Name=sellersagentagencyname;" +
    "Seller's Agent Agency Phone=sellersagentagencyphone;" +
    "Seller's Agent Agency Logo URL=sellersagentagencylogourl;" +
    "Seller's Agent Agency Logo=sellersagentagencylogo;" +
    "Seller's Agent Agency Address=sellersagentagencyaddress;" +
    "Seller's Agent Last Name=sellersagentlastname;" +
    "Seller's Agent Email=sellersagentemail;" +
    "Seller's Agent Web Site (URL)=sellersagenturl;" +
    "Seller's Agent Web Site Link (clickable link)=sellersagenturllink;" +
    "Seller's Agent Work Phone=sellersagentworkphone;" +
    "Seller's Agent Mobile=sellersagentmobile;" +

    "Seller's Agent Photo (75px)=sellersagentimage75;" +
    "Seller's Agent Photo (100px)=sellersagentimage100;" +
    "Seller's Agent Photo (150px)=sellersagentimage150;" +
    "Seller's Agent Photo (250px)=sellersagentimage250;" +

    "Agent Display Name (for Mass Emails)=agentdisplayname;" +
    "Agent First Name (for Mass Emails)=agentfirstname;" +
    "Agent Last Name (for Mass Emails)=agentlastname;" +
    "Agent Email (for Mass Emails)=agentemail;" +
    "Email Subject=subject;Day=day;Year=year;" +
    "Day (Today)=day;" +
    "Year (Today)=year;" +
    "Month (Today)=month;" +
    "Date (Today)=date;" +
    "Time (Today)=time;" +
    "Long Date=date-long;" +
    "Long Date (no day name)=date-long-no-dayname;" +
    "Company Name=company;" +
    "Office Name=officename;" +
    "Office Phone=officephone;" +
    "Office Fax=officefax;" +
    "Office Facebook URL=officefacebookurl;" +
    "Office Twitter URL=officefacebookurl;" +
    "Office Google Plus URL=officegoogleplusurl;" +
    "Office YouTube URL=officeyoutubeurl;" +
    "Office LinkedIn URL=officelinkedinurl;" +
    "Office Yelp URL=officeyelpurl;" +
    "Office Angie's List URL=officeangieslisturl;" +
    "Office Instagram URL=officeinstagramurl;" +
    "Office Facebook Button=officefacebookbutton;" +
    "Office Google Plus Button=officegoogleplusbutton;" +
    "Office Twitter Button=officetwitterbutton;" +
    "Office YouTube Button=officeyoutubebutton;" +
    "Office LinkedIn Button=officelinkedinbutton;" +
    "Office Yelp Button=officeyelpbutton;" +
    "Office Angie's List Button=officeangieslistbutton;" +
    "Office Instagram Button=officeinstagrambutton;" +
    "Company Logo=companylogo;" +
    "Amount Due=amountdue;" +
    "Agreement Link=agreementlink;" +
    "Agreement URL=agreementurl;" +
    "Pay for Inspection Link=paymentlink;"+
    "Pay for Inspection URL=paymenturl;"+
    "Report Link=reportlink;" +
    "Report URL=reporturl;" +
    "Invoice Link=invoicelink;" +
    "Invoice URL=invoiceurl;" +
    "Attachment Link=attachmentlink;" +
    "Attachment URL=attachmenturl;" +
    "Unsubscribe Link=unsubscribelink;" +
    "Unsubscribe URL=unsubscribeurl;" +
    "Escrow Officer Name=escrowofficername;" +
    "Escrow Officer Work Phone=escrowofficerworkphone;" +
    "Escrow Officer Mobile=escrowofficermobile;" +
    "Escrow Officer Fax=escrowofficerfax;" +
    "Escrow Officer Email=escrowofficeremail;" +
    "Escrow Officer URL=escrowofficerurl;" +
    "Escrow Officer Address=escrowofficeraddress;" +
    "Escrow Office Name=escrowofficename;" +
    "Escrow Office Address=escrowofficeaddress;" +
    "Escrow Office Phone=escrowofficephone;" +
    "Escrow Office Fax=escrowofficefax;" +
    "Escrow Office Email=escrowofficeemail;" +
    "Escrow Office URL=escrowofficeurl;" +
    "Bill to Escrow (Y|N)=billtoescrow;" +
    "Escrow Number=escrownumber;" +
    "Closing Date=escrowclosingdate;" +
    "24 Hour Schedule Link=inspector-schedule-link-24-hours;" +
    "24 Hour Schedule Url=inspector-schedule-url-24-hours;" +
    "48 Hour Schedule Link=inspector-schedule-link-48-hours;" +
    "48 Hour Schedule Url=inspector-schedule-url-48-hours;" +
    "Refund Amount=refund-amount;" +
    "Radon Drop Date=radon-drop-date;" +
    "Radon Drop Time=radon-drop-time;" +
    "Radon Drop Date/Time=radon-drop-datetime;" +
    "Radon Drop Owner=radon-drop-owner;" +
    "Radon Pickup Date=radon-pickup-date;" +
    "Radon Pickup Time=radon-pickup-time;" +
    "Radon Pickup Date/Time=radon-pickup-datetime;" +
    "Radon Pickup Owner=radon-pickup-owner;" +
    "Radon Drop Confirmed By Inspector=radon-drop-confirmed;" +
    "Radon Pickup Confirmed by Inspector=radon-pickup-confirmed;" +
    "Radon Drop Equipment=radon-drop-equipment;" +
    "Radon Pickup Equipment=radon-pickup-equipment;" +
    "Radon Event Type=radon-event-type;" +
    "Radon Event Notes=radon-event-notes;" +
    "Radon Appointment Type=radon-appointment-type;" +
    "Radon Contact Type=radon-contact-type;" +
    "Radon Contact Name=radon-contact-name;" +
    "Radon Contact Mobile Phone=radon-contact-mobile;" +
    "Radon Contact Email=radon-contact-email;" +
    "Radon Owner Initials=radon-owner-initials;" +
    "Sample Report URL=sample-report-url;" +
    "Sample Report Link=sample-report-link;" +
    "Repair Request List Link=rrllink;" +
    "Repair Request List Url=rrlurl;" +
    "Survey Monkey URL=survey-monkey-url;" +
    "Survey Monkey Short URL=survey-monkey-short-url;" +
    "Survey Monkey Link=survey-monkey-link;" +
    "Payment Request Amount=payment-request-amount;" +
    "Payment Request Amount=payment-request-amount-formatted;" +
    "Payment Request Payor Name=payment-request-payor-name;" +
    "Payment Request Payor Email=payment-request-payor-email;" +
    "Payment Request Notes=payment-request-notes;" +
    "Payment Request Payment Date=payment-request-payment-date;" +
    "Payment Request Services=payment-request-services;" +
    "Payment Request URL=payment-request-url;" +
    "Payment Request Link=payment-request-link",

    load_replacement_values: function(el, additionalReplacementValues) {
        var fields = this.replacement_values.split(';');;
        if (typeof additionalReplacementValues == 'object') {
            for (var i = 0, l = additionalReplacementValues.length; i < l; i++) {
                fields.unshift(additionalReplacementValues[i]);
            }
        }
        for (var i = 0, l = fields.length; i < l; i++) {
            var field = fields[i],
                values = field.split('=');

            if (values.length == 2 && values[1] != '') {
                $('<option value="' + values[1] + '">').text(values[0] + ' (%' + values[1] + '%)').appendTo(el);
            } else if (values.length == 1 && values[0] != '') {
                $('<option value="' + values[0] + '">').text('%' + values[0] + '%').appendTo(el);
            }
        }
    },

    load_iframe_bs_modal: function(iframesrc, modalTitle, width, height, buttons, options) {
        var defaults = {
            id: 'myModal',
            onShow: function() {},
            onHide: function() {}
        };
        var settings = $.extend({}, defaults, options);
        var container = $('<div class="modal fade" id="' + settings.id + '" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">');
        container.html(
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel"></h4>' +
            '</div>' +
            '<div class="modal-body"></div>' +
            '<div class="modal-footer"></div>' +
            '</div>' +
            '</div>'
        );

        if (width > 0) {
            container.find('.modal-dialog').css('width', width + 'px');
        } else if (typeof width == 'string' && width != '') {
            container.find('.modal-dialog').css('width', width + '%');
        }

        if (height > 0) {
            container.find('.modal-body').css('min-height', height + 'px');
        }

        var body = container.find('.modal-body'),
            header = container.find('.modal-header'),
            footer = container.find('.modal-footer');

        if (modalTitle != '') {
            header.find('.modal-title').text(modalTitle);
        }

        if (typeof buttons == 'object') {
            buttons.forEach(function(button) {
                footer.append(button);
            });
        }

        container.modal();

        container.on('hidden.bs.modal', function (e) {
            $(this).remove();
            if (typeof settings.onHide === 'function') {
                settings.onHide.call();
            }
        })

        container.on('show.bs.modal', function (e) {
            var iframe = $('<iframe>').css({
                'border': '0',
                'width': '100%',
                'height': height + 'px'
            }).appendTo(body);

            if (iframesrc && '' !== iframesrc) {
                iframe.prop('src', iframesrc);
            }
        });

        if (typeof settings.onShow === 'function') {
            container.on('shown.bs.modal', settings.onShow);
        }

        container.modal('show');

    },

    load_print_iframe: function (modalTitle, contentSrc, width, height) {
        var options = {
            id: 'print-modal',
            onShow: function() {
                setTimeout(function() {
                    $('#print-modal').find('iframe')[0].contentWindow.print();
                }, 1750);
            }
        };
        var buttons = [
            $('<button type="button" class="btn btn-info">').html('<i class="fa fa-print"></i> Print').on('click', function () {
                var frame = $(this).parents('.modal-content').find('iframe')[0].contentWindow;
                frame.print();
            }),
            $('<button type="button" class="btn btn-default" data-dismiss="modal">').text('Close')
        ];
        ISN.load_iframe_bs_modal(contentSrc, modalTitle, width, height, buttons, options);
    },

    build_bs_table: function (header, rows) {
        console.log(header);
        console.log(rows);
    },

    init: function(options) {
        this.settings = jQuery.extend( this.settings, options );
        this.init_logentries();
        jQuery( function() {
            ISN.init_dom();
            ISN.init_fastsearch();
            ISN.init_handlebars_helpers();
            setTimeout(function () {
                officeTask.updateTasksDueBadge();
            }, 2500);
            jQuery(window).load( function() { jQuery.jheartbeat.set( {  url: ISN.get_url('/heartbeat'), delay: 1200000  }  ); } );
            $('body').tooltip({
                selector: '[data-toggle="tooltip"]'
            });            
        });
    },

    init_dom: function() {
        ISN.dom.global = jQuery("div#global");
        ISN.dom.headermenu = jQuery("div#headermenu");
        ISN.dom.logo = jQuery('#homelogo');
        jQuery(".tip,.tipsy").tipsy( { gravity: "w" } );
        jQuery("a[rel='external']").click( function() { this.target = "_blank"; } );
    },

    init_fastsearch: function() {

        FastSearch.init( { input_selector:"#isn_search", url: ISN.get_url('/fastsearch'), select:FastSearch.open } );
        $("#isn_search").textboxhint( { hint: "search inspections, agents, clients and more", classname: "fastSearchHint" } );

    },

    init_logentries: function () {
        var windowOnError = null;

        if (!this.LE) {
            LE.init(this.settings.logentries_api_key);
            this.LE = LE;

            if (typeof window.onerror == 'function') {
                windowOnError = window.onerror;
            }

            window.onerror = function (message, url, line, col, error) {
                if (typeof windowOnError == 'function') windowOnError.apply(this, arguments);
                var stack = '';
                if (typeof error == 'object' && error && error.hasOwnProperty('stack')) {
                    stack = error.stack;
                }
                var data = {
                    'companykey': ISN.settings.companykey,
                    'user': ISN.settings.user,
                    'message': message,
                    'url': url,
                    'line': line,
                    'col': col,
                    'stack': stack
                };
                ISN.LE.error(data);
            };
        }
    },

    init_handlebars_helpers: function () {
        window.Handlebars.registerHelper('truncate', function(str, limit, suffix) {
            if (str && typeof str === 'string') {
                var ch = typeof suffix === 'string' ? suffix : '';
                if (str.length > limit) {
                    return new Handlebars.SafeString(String(str).slice(0, limit - ch.length) + ch);
                }
                return new Handlebars.SafeString(str);
            }
        });
        window.Handlebars.registerHelper('bsDateMinutesCompareContextualClass', function (date, leftClass, middleClass, rightClass) {
            var now = new XDate();
            var date = new XDate(date);
            var diff = parseInt(date.diffMinutes(now));
            if (diff > 0) {
                return leftClass;
            } else if (diff < 0) {
                return rightClass;
            }
            return middleClass;
        });
    },

    open_send_agreement_dialog: function(oid) {
        $.get("/" + ISN.settings.companykey + "/orders/sendagreement?new=1&oid=" + oid,
            function (result) {
                ISN.send_agreement_dialog = bootbox.dialog(
                    {
                        size: 'large',
                        message: result,
                        title: 'Send or Sign Agreement',
                        onEscape: function() {console.log('hidden');},
                        backdrop: true,
                        buttons: {
                            cancel: {
                                label: 'Close',
                                className: 'btn-danger'
                            }
                        }
                    }
                );
            }
        )
    },

    open_invoice_dialog: function (oid) {

        var container = $('<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">');
        container.html(
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel"></h4>' +
            '</div>' +
            '<div class="modal-body"></div>' +
            '<div class="modal-footer"></div>' +
            '</div>' +
            '</div>'
        );

        var width, height, windowWidth = $(window).width(), windowHeight = $(window).height();

        // width = windowWidth < 1024 ? windowWidth-100 : window;
        width = (windowWidth > 1450 ? 1450 : windowWidth)-100;

        container.find('.modal-dialog').css('width', width + 'px');
        //container.find('.modal-body').css('height', height + 'px');

        var body = container.find('.modal-body'),
            header = container.find('.modal-header'),
            footer = container.find('.modal-footer');

        header.find('.modal-title').text('Invoices for OID ' + oid);

        if (typeof buttons === 'object') {
            buttons.forEach(function(button) {
                footer.append(button);
            });
        }

        footer.append(
            '<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>'
        );

        container.modal();

        container.on('hidden.bs.modal', function (e) {
            $(this).remove();
        });

        container.on('show.bs.modal', function (e) {
            body.append('<div class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></div>');
            $.get("/" + ISN.settings.companykey + "/customer-invoice/order?oid=" + oid,
                function (result) {
                    body.empty().append(result);
                }
            );
        });

        container.modal('show');
    },

    logout: function() {
        bootbox.confirm({
            size: "small",
            message: '<i class="fa fa-power-off fa-4x" aria-hidden="true"></i>Are you sure you want to logout?',
            buttons: {
                confirm: {
                    label: 'Logout',
                    className: 'btn-danger'
                },
                cancel: {
                    label: 'Wait, No!',
                    className: 'btn-default'
                }
            },
            callback: function(result){
                if(result) {
                    if(window.pendo){
                        window.pendo.clearSession();
                    }
                    window.location = "/"+ISN.settings.companykey+"/logout";
                }
            }
        })
    },

    confirm_box: function (urlOrFn,msg,goMessage,cancelMessage) {
        var box = bootbox.confirm({
            message: msg,
            buttons: {
                confirm: {
                    label: goMessage,
                    className: 'btn-success'
                },
                cancel: {
                    label: cancelMessage,
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if(result) {
                    if (typeof urlOrFn === 'function') {
                        urlOrFn.call(undefined);
                    } else {
                        window.location = urlOrFn;
                    }
                }
            }
        });
        box.css({
            'top': '50%',
            'margin-top': function () {
                return -(box.height() / 2);
            }
        });
    },

    alert_box: function(msg) {
        var box = bootbox.alert(msg);
        box.css({
            'top': '50%',
            'margin-top': function () {
                return -(box.height() / 2);
            }
        });
    },

    close_send_agreement_dialog: function() {
        if(ISN.send_agreement_dialog) {
            ISN.send_agreement_dialog.modal('hide');
        }
    },

    add_visualization_callback: function(callback) {
        if (ISN.settings.visualization_loaded) {
            callback();
        }
        else {
            ISN.settings.visualization_callbacks.push(callback);
        }
    },

    visualization_ready: function() {
        ISN.settings.visualization_loaded = true;
        for (var i = 0, len = ISN.settings.visualization_callbacks.length; i < len; i++) {
            ISN.settings.visualization_callbacks[i]();
        }
    },

    show_quick_guide_popup: function() {
        $.post(
            '/'+ISN.settings.companykey+'/help/quick-guide-popup',
            {

            },
            function (json) {
                bootbox.dialog(
                    {
                        size: 'large',
                        message: json.content,
                        title: 'ISN Quick Guide - Find Help for Common Items and Tasks',
                        buttons: {
                            cancel: {
                                label: 'Close',
                                className: 'btn-danger'
                            }
                        }
                    }
                );
            }
        );
        return false;
    },

    show_dialog_modal_from_get: function(url,data,dialogSize,title) {

        if(!title || title == "") {
            title = null;
        }

        var box = bootbox.dialog(
            {
                show: false,
                size: dialogSize,
                message: '&nbsp;',
                title: title
            }
        );

        $.get(
            url,
            data,
            function (content) {
                box.find('.bootbox-body').html(content);
                box.modal('show');
            }
        );

        return box;
    },

    show_dialog_modal_from_post: function(url,data,dialogSize,title) {

        if(!title || title == "") {
            title = null;
        }

        var box = bootbox.dialog(
            {
                show: false,
                size: dialogSize,
                message: '&nbsp;',
                title: title
            }
        );

        $.post(
            url,
            data,
            function (content) {
                box.init(function () {
                    box.find('.bootbox-body').html(content);
                    box.modal('show');
                });
            }
        );

        return box;
    },

    /**
     *
     * @param templateSelectorOrString
     * @param bootboxOptions
     * @param events
     */
    show_dialog_from_template: function (templateSelectorOrString, bootboxOptions, events) {
        var box;
        var templateEl;
        var originalElParent;
        var defaults = {};
        var defaultEvents = {
            open: function () {},
            close: function () {}
        };
        var b_isTemplate = false;

        bootboxOptions = $.extend(defaults, bootboxOptions);
        events = $.extend(defaultEvents, events);
        templateEl = $(templateSelectorOrString);

        if (templateEl.length > 0) {
            originalElParent = templateEl.parent();
            bootboxOptions.message = function () {
                templateEl.appendTo($(this)).show();
            };
            b_isTemplate = true;
        } else {
            bootboxOptions.message = templateSelectorOrString;
        }

        bootboxOptions.show = true;

        box = bootbox.dialog(bootboxOptions);

        box.on('shown.bs.modal', function () {
            events.open.call(undefined, box);
        });

        box.on('hide.bs.modal', function () {
            if (b_isTemplate) {
                templateEl.appendTo(originalElParent).hide();
            }
        });

        box.on('hidden.bs.modal', function () {
            events.close.call();
            box = null;
        });
    },

    activateTab: function (tabName) {
        $('.nav-tabs a[href="#' + tabName + '"]').tab('show');
    },

    googlemaps: {
        /**
         * @var boolean sensor
         * @var string callback
         */
        init: function() {
            var callback = '',
                sensor = false;

            if(arguments.length >= 2) {
                var arg1 = arguments[0],
                    arg2 = arguments[1];

                if (typeof arg1 == 'string') {
                    callback = arg1;
                } else {
                    sensor = arg1;
                }

                if (typeof arg2 == 'boolean') {
                    sensor = arg2;
                } else {
                    callback = arg2;
                }
            }
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + ISN.settings.gapi_v3_key + '&sensor=' + (sensor ? 'true' : 'false') +
                (callback != '' ? '&callback=' + callback : '') + '&libraries=marker';
            document.body.appendChild(script);
        }
    },

    redactor_modify_font_size: function(obj, event, key) {
        if ( key.match( /^fontsize(\d+)$/ ) ) {
            obj.execCommand('fontSize', RegExp.$1);
            // execCommand fontSize is not HTML5 compliant (<font> is deprecated)
            // replace tags with equivalent spans with font size css
            var code = obj.getCode();
            var markup = $('<div/>').html(code);
            markup.find('font').each(function() {
                var size = $(this).attr('size');
                $(this).contents().unwrap().wrap('<span style="font-size:' + (
                        size == 2 ? '10pt' : (
                            size == 3 ? '11pt' : (
                                size == 4 ? '12pt' : (
                                    size == 5 ? '13pt' : (
                                        size == 6 ? '14pt' : (
                                            size == 7 ? '18pt' : '11pt'
                                        )
                                    )
                                )
                            )
                        )
                    ) + '">');
            });
            obj.setCode(markup.html());
        } else if ( key == 'nofontsize' ) {
            obj.execCommand('removeFormat', key);
        }
    },

    live_chat: function() {
        Intercom('show');
    },

    get_support_phone_number: function() {
        if (this.settings.ams) {
            return '(888) 327-0269 ext 8518';
        } else if (this.settings.win) {
            return '(206) 694-8025';
        } else {
            return '(800) 700-8112';
        }
    },

    get_url: function(url) {
        return '/'+ISN.settings.companykey+url;
    },

    hide_system_message: function() {
        ISN.dom.system_message.hide();
        jQuery.Storage.set('systemMessageClosed','true');
        jQuery.Storage.set('systemMessageId', ISN.settings.system_message_id);
        ISN.dom.logo.css('padding-top', 0 );
    },

    set_font_size: function(size) {
        ISN.settings.fontsize = size;
        $.post('/'+ISN.settings.companykey+'/usersettings/save',{ key:'CONTENT_FONT_SIZE', value:ISN.settings.fontsize }, function(json) { }, 'json');
        ISN.dom.global.css('font-size',ISN.settings.fontsize+'em');
    },

    font_increase_size: function() {
        ISN.set_font_size( ISN.settings.fontsize + 0.05 );
    },

    font_decrease_size: function() {
        ISN.set_font_size( ISN.settings.fontsize - 0.05 );
    },

    font_reset_size: function() {
        ISN.set_font_size( 1.1 );
    },
    getSlug: function(terms) {
        return terms.toLowerCase()
            .replace(/[^\w ]+/g,'')
            .replace(/ +/g,'-');
    },
    addslashes: function(str) {
        return str.replace(/\'/g, "\\\'").replace(/\"/g, "\\\"");
    },
    stripslashes: function(str) {
        str = str.replace(/\\'/g,'\'');
        str = str.replace(/\\"/g,'"');
        str = str.replace(/\\0/g,'\0');
        str = str.replace(/\\\\/g,'\\');
        return str;
    },
    escapequotes: function(str) {
        return str.replace(/\"/g, '&quot;');
    },
    unescapequotes: function(str) {
        return str.replace(/&quot;/g, '"');
    },
    rawurlencode: function(str) {
        str = (str+'').toString();
        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A');
    },
    rawurldecode: function(str) {
        return decodeURIComponent(str + '')
    },
    open_add_task_modal: function (taskdata, cb) {
        var xhr = null;
        var onShow = function () {
            $('#addtask-duedte').datepicker();
            $('#addtask-message').focus();
            $('#recently-added-tasks-loading').show();
            var table = $('#recently-added-tasks-table');
            table.find('tbody').children().detach();
            table.find('thead').hide();
            $.getJSON('/' + ISN.settings.companykey + '/office-task/recent', function (json) {
                if (json.tasks.length > 0) {
                    table.find('thead').show();
                    for (var i = 0; i < json.tasks.length; i++) {
                        table.append(
                            $('<tr>').append(
                                $('<td>').text(json.tasks[i].message),
                                $('<td>').text(json.tasks[i].due)
                            )
                        );
                    }
                } else {
                    table.find('thead').hide();
                    table.append(
                        $('<tr>').append(
                            $('<td colspan="2">').text('No recently added tasks')
                        )
                    );
                }
                $('#recently-added-tasks-loading').hide();
            });
        };

        $("#addtask-oid").typeahead({
            source: function(query, process) {
                $.getJSON('/' + ISN.settings.companykey + '/autocomplete/order-no-markup',
                    {
                        term: query, limit: 15
                    },
                    process
                );
            },
            displayText: function(item) {
                return item.label;
            },
            afterSelect: function(item) {
                $("#addtask-oid").val(item.id)
            }
        });

        $('#addtask-reminders').hide();

        $('#addtask-remindemail').unbind();
        $('#addtask-remindemail').on('click', function () {
            if ($(this).is(':checked') || $('#addtask-remindsms').is(':checked')) {
                $('#addtask-reminders').show();
            } else {
                $('#addtask-reminders').hide();
            }
        });

        $('#addtask-remindsms').unbind();
        $('#addtask-remindsms').on('click', function () {
            if ($(this).is(':checked') || $('#addtask-remindemail').is(':checked')) {
                $('#addtask-reminders').show();
            } else {
                $('#addtask-reminders').hide();
            }
        });

        $('#addTaskModal').modal();
        $('#addTaskModal').unbind('shown.bs.modal');
        $('#addTaskModal').on('shown.bs.modal', onShow);
        $('#addTaskModal').modal('show');

        $('#addtask-duedte').datepicker("destroy");
        $('#add-task-btn').unbind();
        $('#add-task-btn').on('click', function () {
            var payload = {
                message: $('#addtask-message').val(),
                assignee: $('#addtask-assignee').val(),
                due: $('#addtask-duedte').val(),
                dueTime: $('#addtask-duedtetime').val(),
                remind: $('#addtask-sendminutes').val(),
                priority: $('#addtask-priority').val(),
                oid: $('#addtask-oid').val(),
                remindemail: $('#addtask-remindemail').is(':checked'),
                remindsms: $('#addtask-remindsms').is(':checked')
            };
            if (typeof taskdata == 'object' && null !== taskdata) {
                payload.id = taskdata.uuid;
            }
            if (payload.remind != '') {
                $.post('/' + ISN.settings.companykey + '/office-task/save', payload, function (json) {
                    if (json.status == 'ok') {
                        $('#addTaskModal').modal('hide');
                        $('#alert').show().prop('class', '').addClass('alert alert-success').text('Successfully saved task!');
                        if (typeof cb == 'function') {
                            cb();
                        }
                    } else {
                        alert(json.message);
                    }
                }, 'json');
            }
        });

        if (typeof taskdata == 'object' && null !== taskdata) {
            $('#addTaskModalLabel').text('Edit Task');
            $('#add-task-btn').text('Save');
            $('#addtask-message').val(taskdata.message);
            $('#addtask-assignee').val(taskdata.assignedToUserId);
            $('#addtask-duedte').val(taskdata.dueDate);
            $('#addtask-duedtetime').val(taskdata.dueTime);
            $('#addtask-sendminutes').val(taskdata.remindMinutesBefore);
            $('#addtask-priority').val(taskdata.priority);
            $('#addtask-oid').val(taskdata.oid);
            if (taskdata.remindEmail) {
                $('#addtask-remindemail').prop('checked', true);
            } else {
                $('#addtask-remindemail').prop('checked', false);
            }
            if (taskdata.remindSms) {
                $('#addtask-remindsms').prop('checked', true);
            } else {
                $('#addtask-remindsms').prop('checked', false);
            }
            if ($('#addtask-remindemail').is(':checked') || $('#addtask-remindsms').is(':checked')) {
                $('#addtask-reminders').show();
            } else {
                $('#addtask-reminders').hide();
            }
        } else {
            $('#addTaskModalLabel').text('Add Task');
            $('#add-task-btn').text('Add');
            $('#addtask-message').val('');
            $('#addtask-duedte').val('');
            $('#addtask-sendminutes').val('');
            $('#addtask-oid').val('');
            $('#addtask-sendminutes').val(20);
            $('#addtask-remindemail').prop('checked', false);
            $('#addtask-remindsms').prop('checked', false);
            $('#addtask-reminders').hide();
        }
    },
    open_accelerator_title_popover: function (popoverData, event) {
        var titles = $('#recent-title-popover');
        titles.find('ul').html('');
        $.each(popoverData, function (key, value) {
            var ele = "<li>" +
                "<a href='#' onclick='updateTitleWithRecent(event)' class='inline-fav-title'"
                + "data-target='" + event.target.id + "'"
                + " data-title='" + value.title_nm + "'"
                + " data-update='" + event.target.dataset.update + "'> " + value.title_nm + "</a></li>";
            titles.find('ul').append(ele);
        });

        titles.find('ul').attr('style', "padding-left:15px; list-style:none; text-align:left; line-height:1.5");
        $("#" + event.target.id).popover({
            container: 'body',
            html: true,
            placement: 'left',
            content: function () {
                var html = $("#recent-title-popover");
                var clone = html.clone().removeClass('hide').attr('id', '');
                return clone.html();
            },
            title: '<div class="title" style="height: 15px;"> ' +
                    '<div style="width:90%; height:15px; display:block; float:left;">Recent Titles </div>' +
                    '<button type="button" id="close" class="close" style="margin-top: -5px;" onclick="closePopover('+"'"+event.target.id +"'"+')">&times;</button></div>'
        });
        $("#" + event.target.id).popover('toggle');
        $("#recent-title-popover").on('blur', function () {
            $("#" + event.target.id).popover('destroy');
        })
    },
    uset: function (key, value, isBool) {
        var payload = { key: key, value: value };
        if (isBool) {
            payload.bool = 1;
        }
        return $.post('/'+ISN.settings.companykey+'/useredit/uset', payload, 'json');
    },
    usetbool: function (key, value) {
        return ISN.uset(key, value, true);
    },
    uget: function (key, cb) {
        if (typeof cb !== 'function') {
            cb = function () {};
        }
        $.getJSON('/'+ISN.settings.companykey+'/useredit/uget?key='+key, function (response) {
            cb(response.value);
        });
    },
    ugetbool: function (key, cb) {
        if (typeof cb !== 'function') {
            cb = function () {};
        }
        ISN.uget(key, cb);
    },
    switchOffice: function(id) {
        $.post('/' + ISN.settings.companykey + '/login/intraoffice', { office_id: id }, function() {
            window.location.reload(true);
        });
    },
    orders: {
        get_macro_text: function (id) {

            $.getJSON('/' + ISN.settings.companykey + '/order-bravo/getmacrotext', { id: id },
                function (json) {
                    $('#new_note_content').redactor('insert.html', '<p>' + json.txt + '</p>' );
                    $('#note_content').redactor('insert.html', '<p>' + json.txt + '</p>' );
                }
            );
        },
        open_add_note_dialog: function(orderuuid, callback) {

            $.getJSON('/' + ISN.settings.companykey + '/order/info/' + orderuuid, $.proxy(function(info_json) {
                var title = 'Add Note • OID ' + info_json.oid + (info_json.reportnumber != '' ? ' • ' + info_json.reportnumber : '') + ' • ' + info_json.address;

                $.getJSON('/' + ISN.settings.companykey + '/order/notes-json/' + orderuuid, $.proxy(function(json) {
                    if (json.status == 'ok') {

                        // css preload
                        var cssSource = 'https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-121/redactor.css';
                        if ($("[href='" + cssSource + "']").length == 0) {
                            // retrieve once
                            $('<link/>', {
                                rel: 'stylesheet',
                                type: 'text/css',
                                href: cssSource
                            }).appendTo('head');
                        }

                        $('<link/>', {
                            rel: 'stylesheet',
                            type: 'text/css',
                            //href: 'https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-121/plugins/alignment/alignment.css'
                            href: 'https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-124/plugins/alignment/alignment.css'
                        }).appendTo('head');

                        // redactor script load w/ cache support (retrieve it once, and possibly from browser cache)
                        //$.cachedScript('https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-121/redactor.min.js').done($.proxy(function() {
                        $.cachedScript('https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-124/redactor/redactor.min.js').done($.proxy(function() {
                            //load plugins
                            //$.cachedScript('https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-121/plugins/plugins.min.js').done($.proxy(function() {
                            $.cachedScript('https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-124/redactor/redactor.min.js').done($.proxy(function() {
                                // scaffolding
                                var container = $('<div>').addClass('container-fixed').css('margin', '10px');
                                $('<div>').addClass('row').appendTo(container);
                                var thirdRow = $('<div>').prop('id', 'macro_row').addClass('row').appendTo(container);
                                var secondRow = $('<div>').addClass('row').appendTo(container);
                                var leftColumn = $('<div>').addClass('span4').appendTo(secondRow);
                                var rightColumn = $('<div>').css({
                                    'max-height': $(window).height() * .35,
                                    'overflow-x': 'hidden',
                                    'overflow-y': 'auto'
                                }).addClass('span5').appendTo(secondRow);


                                var editor = $('<textarea>').prop('id', 'new_note_content').appendTo(leftColumn);
                                editor.redactor({
                                    convertDivs: false,
                                    cleanup: false,
                                    autoresize: false,
                                    focus: true,
                                    minHeight: $(window).height() * .20,
                                    allowedTags: ISN.settings.redactor_allowed_tags,
                                    buttons: ISN.settings.redactor,
                                    plugins: ['source', 'table', 'alignment'],
                                    buttonsCustom: {
                                        fs: ISN.settings.redactor_btns.fontsize
                                    }
                                });

                                var emailOptionsContainer = $('<div>').appendTo(leftColumn).html(
                                    '<input type="checkbox" name="send_email_to_owners" id="send_email_to_owners" /> <label for="send_email_to_owners">Send an email notification to the owners</label>' +
                                    '<br />' +
                                    '<input type="checkbox" name="send_email_to_inspectors" id="send_email_to_inspectors" /> <label for="send_email_to_inspectors">Send an email notification to the inspectors</label>' + 
                                    '<br />' +
                                    '<input type="checkbox" name="send_email_to_managers" id="send_email_to_managers" /> <label for="send_email_to_managers">Send an email notification to the office manager</label>'
                                );

                                if (json.hasOwnProperty('macro')) {
                                    thirdRow.css('margin-bottom', '5px');
                                    var label = $('<label>').addClass('col-md-2').css('padding-top', '5px')
                                        .prop('for', 'addnotemacros').text('Insert Note:').appendTo(thirdRow);
                                    var selectContainer = $('<div>').addClass('col-md-10').appendTo(thirdRow);
                                    var select = '<select name="addnotemacros" class="form-control" id="addnotemacros" onchange="ISN.orders.get_macro_text( $(this).val() );return false;">';

                                    $.each(json.macro, function (index, mac) {
                                        select += ' <option value="' +mac.key+ '" class="form-control option" id="addnotemacros-'+mac.key+'"> ' +
                                            mac.value+'</option>';
                                    });
                                    select += '</select>';
                                    selectContainer.append($(select));
                                } else {
                                    $('#macro_row').remove();
                                }
                                var noteTable = $('<table>').addClass('table table-striped').appendTo(rightColumn);
                                var c = 0;
                                for (var i in json.notes) {
                                    if (json.notes.hasOwnProperty(i)) {
                                        c++;
                                        var note = json.notes[i];
                                        var tr = $('<tr>').appendTo(noteTable);
                                        var td = $('<td>').appendTo(tr);
                                        var noteContainer = $('<div>').addClass('container-fixed');
                                        var noteFirstCol = $('<div>').css({
                                            'display': 'inline-block',
                                            'width': '18%',
                                            'vertical-align': 'top'
                                        });
                                        var noteSecondCol = $('<div>').css({
                                            'display': 'inline-block',
                                            'width': '78%',
                                            'padding-left': '5px',
                                            'vertical-align': 'top'
                                        });
                                        noteContainer.append(noteFirstCol, noteSecondCol);
                                        $('<div>').css('font-size', '0.95em').html('<p style="text-align:center;"><img src="' + note.owner_gravatar + '"/></p><p style="text-align:center;"><strong>' + note.owner_display_name + '</strong></p>').appendTo(noteFirstCol);
                                        $('<div>').css('font-size', '0.95em').html('<p class="muted">' + note.created_dte + '</p><p>' + note.content + '</p>').appendTo(noteSecondCol);
                                        td.append(noteContainer);
                                    }
                                }

                                if (c == 0) {
                                    rightColumn.append($('<div class="alert alert-info"><strong>There are no notes for this order</strong></div>'));
                                }

                                bootbox.dialog(
                                    {
                                        size: 'large',
                                        message: container,
                                        title: title,
                                        buttons: {
                                            addNote : {
                                                label: 'Add Note',
                                                className: "btn btn-success",
                                                callback: function() {
                                                    $.post('/' + ISN.settings.companykey + '/order/add-note/' + orderuuid, { content: $('#new_note_content').redactor('code.get'), send_email_to_owners: ($('#send_email_to_owners:checked').length > 0) ? 1 : 0, send_email_to_inspectors: ($('#send_email_to_inspectors:checked').length > 0) ? 1 : 0, send_email_to_managers: ($('#send_email_to_managers:checked').length > 0) ? 1 : 0 }, function(json) {
                                                        if (json.status == 'ok') {
                                                            if (typeof callback == 'function') {
                                                                callback();
                                                            } else {
                                                                alert('Note has been added to OID ' + json.oid);
                                                            }
                                                        }
                                                    }, 'json')
                                                }
                                            },
                                            cancel: {
                                                label: 'Cancel',
                                                className: 'btn-danger'
                                            }
                                        }
                                    }
                                );


                            }, this));
                        }, this));
                    }

                }, this));


            }, this));


        },
        open_add_propertyphoto_dialog: function(orderuuid, callback) {
            var dialog = $('<div>').dialog({
                resizable: false,
                draggable: false,
                modal: true,
                position: ['center', 75],
                width: 850,
                minHeight: 470,
                zIndex: 3999,
                title: 'Property Photo',
                open: function() {

                    $.getJSON('/' + ISN.settings.companykey + '/order/info/' + orderuuid, $.proxy(function(json) {
                        $(this).dialog('option', 'title', 'Property Photo &middot; OID ' + json.oid + (json.reportnumber != '' ? ' &middot; ' + json.reportnumber : '') + ' &middot; ' + json.address)
                    }, this));

                    $(this).html('<div style="text-align:center;"><img src="https://dlil96nns7nd5.cloudfront.net/images/wait-images/wait30trans.gif"/></div>');

                    $.getJSON('/' + ISN.settings.companykey + '/propertyphoto/url/' + orderuuid, { size: 250 }, $.proxy(function(json) {
                        if (json.status == 'ok') {
                            $.cachedScript('https://dlil96nns7nd5.cloudfront.net/scripts/plupload2/plupload.full.min.js').done($.proxy(function() {
                                // scaffolding
                                var container = $('<div>');
                                var left = $('<div>').addClass('span4');
                                var right = $('<div>').addClass('span4').prop('id', 'propertyphoto-uploader');
                                container.append(left, right);

                                var currentPhoto = $('<img id="propertyphoto-currentphoto" src="' + json.url + '" style="width:250px;border:1px solid #f2f2f2;"/>');

                                left.append(
                                    $('<div>').addClass('span3').css({ 'position': 'relative', 'top': '10px' }).append(
                                        currentPhoto,
                                        $('<div>').addClass('caption').append(
                                            $('<p>').append(
                                                $('<p>').addClass('muted').css('padding-top', '10px').append(
                                                    $('<div>').html('Address: <strong>' + json.address + '</strong>'),
                                                    $('<div>').html('Date/Time: <strong>' + (json.datetime == null ? 'Not Scheduled' : json.datetime) + '</strong>')
                                                ),
                                                $('<div>').addClass('btn-group').css({ 'padding-top': '10px' }).append(
                                                    $('<button>').click(function() { window.location = '/' + ISN.settings.companykey + '/o/view/?oid=' + json.oid }).prop('id', 'propertyphoto-view-order').addClass('btn').html('<i class="icon-exclamation-sign"></i> View Order'),
                                                    $('<button>').click(function() { window.location = '/' + ISN.settings.companykey + '/o/edit/?oid=' + json.oid }).prop('id', 'propertyphoto-edit-order').addClass('btn').html('<i class="icon-pencil"></i> Edit Order')
                                                ),
                                                $('<button>').prop('id', 'remove-propertyphoto-btn').css({
                                                    'display': json.exists == 'false' ? 'none' : 'block',
                                                    'margin-top': '10px'
                                                }).addClass('btn btn-danger').html('<i class="icon-trash icon-white"></i> Remove this Property Photo').click(function() {
                                                    if (confirm('Are you sure?')) {
                                                        $('#propertyphoto-currentphoto').fadeOut(function() {
                                                            $.post('/' + ISN.settings.companykey + '/propertyphoto/remove/' + orderuuid, function(json) {
                                                                $('#propertyphoto-currentphoto').prop('src', 'http://dlil96nns7nd5.cloudfront.net/images/missing-property-photo-250.jpg').fadeIn();
                                                                $('#remove-propertyphoto-btn').hide();
                                                            }, 'json');
                                                        });
                                                    }
                                                })
                                            )
                                        )
                                    )
                                );

                                right.append(
                                    $('<div>').prop('id', 'propertyphoto-upload-message').css('margin', '5px').html(
                                        '<button type="button" class="close" data-dismiss="alert">&times;</button><span id="propertyphoto-upload-message-text"></span>'
                                    ).hide()
                                );

                                var uploadProgress = $('<div>').prop('id', 'propertyphoto-uploader-progress').appendTo(right);
                                uploadProgress.html('<div class="progress"><div class="bar" id="propertyPhotoProgressBar" style="width:0%;"></div>');
                                var dropTarget = $('<div>').prop('id', 'propertyphoto-drop-target').addClass('drop-target').appendTo(right);
                                uploadProgress.hide();

                                $(this).html('').append(container);

                                dropTarget.html('Drop your Image here<br/>or<br/>Click to Browse');

                                var propertyPhotoUploader = new plupload.Uploader({
                                    container: 'propertyphoto-uploader',
                                    runtimes: 'html5,flash,silverlight,html4',
                                    url: '/' + ISN.settings.companykey + '/propertyphoto/u/' + orderuuid,
                                    max_file_size: '10mb',
                                    drop_element: 'propertyphoto-drop-target',
                                    browse_button: 'propertyphoto-drop-target',
                                    multi_selection: false,
                                    filters : [
                                        { title : "Image files", extensions : "jpg,jpeg,gif,png,bmp" }
                                    ],
                                    flash_swf_url: 'http://www.plupload.com/plupload/js/plupload.flash.swf',
                                    silverlight_xap_url: 'http://www.plupload.com/plupload/js/plupload.silverlight.xap',
                                    init : {
                                        FilesAdded: function(up, files) {
                                            up.start();
                                            $('#propertyphoto-drop-target').hide();
                                            $('#propertyphoto-uploader-progress').show();
                                            for (var i in files) {
                                                if (files[i].id !== undefined) {
                                                    $('#filelist').html(files[i].name + ' (' + plupload.formatSize(files[i].size) + ')');
                                                }
                                            }
                                        },
                                        FileUploaded: function(up, file, info) {
                                            $('#propertyphoto-drop-target').show();
                                            var obj = JSON.parse(info.response);
                                            if (obj.error) {
                                                $('#propertyphoto-upload-message').removeClass('alert-success').addClass('alert alert-error').show();
                                                $('#propertyphoto-upload-message-text').text("Error uploading your property photo: \n\n"+obj.error.message);
                                            }
                                        },
                                        UploadComplete: function(up, files) {
                                            $('#propertyphoto-currentphoto').fadeOut(function() {
                                                $.getJSON('/' + ISN.settings.companykey + '/propertyphoto/url/' + orderuuid, { size: 250 }, function(json) {
                                                    $('#propertyphoto-currentphoto').prop('src', json.url).fadeIn();
                                                    $('#propertyphoto-uploader-progress').hide();
                                                    $('#propertyphoto-upload-message').removeClass('alert-error').addClass('alert alert-success').show();
                                                    $('#propertyphoto-upload-message-text').text('Property photo has been successfully uploaded!');
                                                    $('#remove-propertyphoto-btn').show();
                                                });
                                            });
                                        }
                                    }

                                });

                                propertyPhotoUploader.bind('UploadProgress', function (up, file) {
                                    var percentage = Number(((propertyPhotoUploader.total.loaded / propertyPhotoUploader.total.size) * 100).toFixed(0));
                                    $('#upload-info').html(parseInt(up.total.bytesPerSec / 1024) + 'Kb/s ' + percentage + '% uploaded');
                                    $('#propertyPhotoProgressBar').css('width', percentage + '%');
                                });

                                propertyPhotoUploader.init();

                            }, this));
                        }
                    }, this));

                },
                close: function() {
                    $(this).html('');
                    $(this).dialog('destroy');
                    if (typeof callback == 'function') {
                        callback();
                    }
                },
                buttons: {
                    Close: {
                        id: 'cancel-add-propertyphoto-btn',
                        'class': 'btn btn-success',
                        text: 'Close',
                        click: function() {
                            $(this).dialog('close');
                        }
                    }
                }
            });
        },
        open_edit_note_dialog: function(orderuuid, noteId, callback) {

            $.getJSON('/' + ISN.settings.companykey + '/order/info/' + orderuuid, $.proxy(function(info_json) {
                var title = 'Edit Note • OID ' + info_json.oid + (info_json.reportnumber != '' ? ' • ' + info_json.reportnumber : '') + ' • ' + info_json.address;

                $.getJSON('/' + ISN.settings.companykey + '/order/notes-json/' + orderuuid, $.proxy(function(json) {
                    if (json.status == 'ok') {

                        // css preload
                        var cssSource = 'https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-121/redactor.css';
                        if ($("[href='" + cssSource + "']").length == 0) {
                            // retrieve once
                            $('<link/>', {
                                rel: 'stylesheet',
                                type: 'text/css',
                                href: cssSource
                            }).appendTo('head');
                        }

                        $('<link/>', {
                            rel: 'stylesheet',
                            type: 'text/css',
                            href: 'https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-124/plugins/alignment/alignment.css'
                        }).appendTo('head');

                        // redactor script load w/ cache support (retrieve it once, and possibly from browser cache)
                        $.cachedScript('https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-124/redactor/redactor.min.js').done($.proxy(function() {
                            //load plugins
                            $.cachedScript('https://dlil96nns7nd5.cloudfront.net/scripts/redactor-2-124/redactor/redactor.min.js').done($.proxy(function() {
                                // scaffolding
                                var container = $('<div>').addClass('container-fixed').css('margin', '10px');
                                $('<div>').addClass('row').appendTo(container);
                                var thirdRow = $('<div>').prop('id', 'macro_row').addClass('row').appendTo(container);
                                var secondRow = $('<div>').addClass('row').appendTo(container);
                                var leftColumn = $('<div>').addClass('span4').appendTo(secondRow);
                                var rightColumn = $('<div>').css({
                                    'max-height': $(window).height() * .35,
                                    'overflow-x': 'hidden',
                                    'overflow-y': 'auto'
                                }).addClass('span5').appendTo(secondRow);


                                var editor = $('<textarea>').prop('id', 'note_content').appendTo(leftColumn);
                                editor.redactor({
                                    convertDivs: false,
                                    cleanup: false,
                                    autoresize: false,
                                    focus: true,
                                    minHeight: $(window).height() * .20,
                                    allowedTags: ISN.settings.redactor_allowed_tags,
                                    buttons: ISN.settings.redactor,
                                    plugins: ['source', 'table', 'alignment'],
                                    buttonsCustom: {
                                        fs: ISN.settings.redactor_btns.fontsize
                                    }
                                });


                                $.get(
                                    '/' + ISN.settings.companykey + '/order/note-markup?nid=' + noteId,
                                    function(note_json) {
                                            noteObj = JSON.parse(note_json);
                                            editor.redactor('code.set', noteObj.markup);
                                    }
                                );

                                if (json.hasOwnProperty('macro')) {
                                    thirdRow.css('margin-bottom', '5px');
                                    var label = $('<label>').addClass('col-md-2').css('padding-top', '5px')
                                        .prop('for', 'addnotemacros').text('Insert Note:').appendTo(thirdRow);
                                    var selectContainer = $('<div>').addClass('col-md-10').appendTo(thirdRow);
                                    var select = '<select name="addnotemacros" class="form-control" id="addnotemacros" onchange="ISN.orders.get_macro_text( $(this).val() );return false;">';

                                    $.each(json.macro, function (index, mac) {
                                        select += ' <option value="' +mac.key+ '" class="form-control option" id="addnotemacros-'+mac.key+'"> ' +
                                            mac.value+'</option>';
                                    });
                                    select += '</select>';
                                    selectContainer.append($(select));
                                } else {
                                    $('#macro_row').remove();
                                }

                                bootbox.dialog(
                                    {
                                        size: 'large',
                                        message: container,
                                        title: title,
                                        buttons: {
                                            addNote : {
                                                label: 'Save Note',
                                                className: "btn btn-success",
                                                callback: function() {
                                                    $.post('/' + ISN.settings.companykey + '/order/edit-note/' + noteId, { content: $('#note_content').redactor('code.get'), nid: noteId }, function(json) {
                                                        if (json.status == 'ok') {
                                                            if (typeof callback == 'function') {
                                                                callback();
                                                            } else {
                                                                alert('Note has been edited ' + json.oid);
                                                            }
                                                        }else{
                                                            alert('Note could not be edited');
                                                        }
                                                    }, 'json')
                                                }
                                            },
                                            cancel: {
                                                label: 'Cancel',
                                                className: 'btn-danger'
                                            }
                                        }
                                    }
                                );

                            }, this));
                        }, this));
                    }

                }, this));

            }, this));


        },

    }

};
